import axios from "axios";

import { basePath, createHeaders } from "./utils";

/**
 * GET
 * /api/alert/notification/contact
 *
 * Returns all notification contact for current org
 */
export const getContacts = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(
        `${basePath}/alert/notification/contact`,
        config
      )
      .then((resp) => {
        console.log("getContacts", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * PUT
 * /api/alert/notification/contact
 *
 * Updates an existing notification contact
 */
export const updateContact = (id, firstName, lastName, nickName, emailAddress, cellPhone) => {
  const config = {};
  config.headers = createHeaders();

  const data = {
    id,
    firstName,
    lastName,
    nickName,
    emailAddress,
    cellPhone,
  };

  return new Promise((resolve, reject) => {
    axios
      .put(
        `${basePath}/alert/notification/contact`, data,
        config
      )
      .then((resp) => {
        console.log("updateContact", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * PUT
 * /api/alert/notification/contact
 *
 * Inserts a new notification contact
 */
export const postContact = (/*firstName, lastName, nickName,*/ contactName, emailAddress, cellPhone) => {
  const config = {};
  config.headers = createHeaders();

  const data = {
    contactName,
    // firstName,
    // lastName,
    // nickName,
    emailAddress,
    cellPhone,
  };

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${basePath}/alert/notification/contact`, data,
        config
      )
      .then((resp) => {
        console.log("postContact", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/notification/configuration/{alertId: string($uuid)}
 * ?includeDeleted={includeDeleted: boolean}
 *
 * Get notification configuration by alert id
 */
export const getNotificationConfiguration = (
  alertId,
  includeDeleted = false
) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(
        `${basePath}/alert/notification/configuration/${alertId}?includeDeleted=${includeDeleted}`,
        config
      )
      .then((resp) => {
        console.log("getNotificationConfiguration", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * PUT
 * /api/alert/notification/configuration/{alertId: string($uuid)}
 *
 * Updates notification configuration
 */
export const updateNotificationConfiguration = (data, alertId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .put(
        `${basePath}/alert/notification/configuration/${alertId}`,
        data,
        config
      )
      .then((resp) => {
        console.log("updateNotificationConfiguration", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * DELETE
 * /api/alert/notification/configuration/{alertId: string($uuid)}
 *
 * Deletes notification configuration
 */
export const deleteNotificationConfiguration = (alertId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .delete(`${basePath}/alert/notification/configuration/${alertId}`, config)
      .then((resp) => {
        console.log("deleteNotificationConfiguration", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/notification/configuration
 * ?includeDeleted={includeDeleted: boolean}
 *
 * Returns all notification configurations for current org
 */
export const getNotificationConfigurations = (includeDeleted = false) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(
        `${basePath}/alert/notification/configuration?includeDeleted=${includeDeleted}`,
        config
      )
      .then((resp) => {
        console.log("getNotificationConfigurations", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * POST
 * /api/alert/notification/configuration
 *
 * Creates a notification configuration
 */
export const postNotificationConfiguration = (data) => {
  const config = {};
  config.headers = createHeaders();

  console.log(data);

  return new Promise((resolve, reject) => {
    axios
      .post(`${basePath}/alert/notification/configuration`, data, config)
      .then((resp) => {
        console.log("postNotificationConfiguration", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/status/types
 *
 * Returns all alert status types
 */
export const getAlertStatusTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/alert/status/types`, config)
      .then((resp) => {
        console.log("getAlertStatusTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/severity/types
 *
 * Returns all alert severity level types
 */
export const getAlertSeverityTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/alert/severity/types`, config)
      .then((resp) => {
        console.log("getAlertSeverityTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/notification/types
 *
 * Returns all alert notification types
 */
export const getNotificationTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/alert/notification/types`, config)
      .then((resp) => {
        console.log("getNotificationTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/notification/status/types
 *
 * Returns all alert notification status types
 */
export const getAlertNotificationStatusTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/alert/notification/status/types`, config)
      .then((resp) => {
        console.log("getAlertNotificationStatusTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/notification/configuration/location/types
 *
 * Returns all notification configuration location types
 */
export const getNotificationConfigurationLocationTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(
        `${basePath}/alert/notification/configuration/location/types`,
        config
      )
      .then((resp) => {
        console.log("getNotificationConfigurationLocationTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/notification/configuration/detail/{alertId: string($uuid)}
 *
 * Returns all notification configuration detail records by alertId
 */
export const getNotificationConfigurationDetailRecords = (alertId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(
        `${basePath}/alert/notification/configuration/detail/${alertId}`,
        config
      )
      .then((resp) => {
        console.log("getNotificationConfigurationDetailRecords", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/info
 * ?page={page: integer($int32)}
 * &size={pageSize: integer($int32)}
 * &sortBy={sortBy: string}
 * &direction={sortDirection: string}
 *
 * Returns all alert info for current org
 */
export const getAlerts = (
  page = 0,
  pageSize = 10,
  sortBy = "createdAt",
  sortDirection = "desc"
) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(
        `${basePath}/alert/info?page=${page}&size=${pageSize}&sortBy=${sortBy}&direction=${sortDirection}`,
        config
      )
      .then((resp) => {
        console.log("getAlerts", resp);
        resolve(resp);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/info/unit/{unitId: string($uuid)}
 * ?page={page: integer($int32)}
 * &size={pageSize: integer($int32)}
 * &sortBy={sortBy: string}
 * &direction={sortDirection: string}
 *
 * Returns all alert info for a charge unit
 */
export const getAlertsByUnitId = (
  unitId,
  page = 0,
  pageSize = 10,
  sortBy = "createdAt",
  sortDirection = "desc",
) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(
        `${basePath}/alert/info/unit/${unitId}?page=${page}&size=${pageSize}&sortBy=${sortBy}&direction=${sortDirection}`,
        config
      )
      .then((resp) => {
        console.log("getAlertsByUnitId", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/fault/types
 *
 * Returns all charge fault types
 */
export const getFaultTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/alert/fault/types`, config)
      .then((resp) => {
        console.log("getFaultTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/alert/custom/notifications/{customAlertId: string($uuid)}
 *
 * Returns all custom alert notifications by alertId
 */
// export const getCustomAlertNotifications = (customAlertId) => {
//   const config = {};
//   config.headers = createHeaders();

//   return new Promise((resolve, reject) => {
//     axios
//       .get(`${basePath}/alert/custom/notifications/${customAlertId}`, config)
//       .then((resp) => {
//         console.log("getCustomAlertNotifications", resp);
//         resolve(resp.data);
//       })
//       .catch((err) => {
//         console.error(err);
//         reject(err);
//       });
//   });
// };

/**
 * GET
 * /api/alert/assignees
 *
 * Returns all alert assignees for current org
 */
export const getAlertAssignees = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/alert/assignees`, config)
      .then((resp) => {
        console.log("getAlertAssignees", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};
